import axios from './api-axios'
import mixins from './common-mixins'

export default {
  axios, mixins
}



// WEBPACK FOOTER //
// ./src/modules/common.js